/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.3.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


import { onConfigChange } from "@microsoft/applicationinsights-core-js";
var Version = '3.3.2';
var Internal = /** @class */ (function () {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */
    function Internal(config, unloadHookContainer) {
        var _this = this;
        var unloadHook = onConfigChange((config), function () {
            var prefix = config.sdkExtension;
            _this.sdkVersion = (prefix ? prefix + "_" : "") + "javascript:" + Version;
        });
        unloadHookContainer && unloadHookContainer.add(unloadHook);
    }
    return Internal;
}());
export { Internal };
//# sourceMappingURL=Internal.js.map